import { ServiceDto } from '../shared/interfaces';

export function setServiceDescription(service: Partial<ServiceDto>): string {
  return (service.codeService ? service.codeService + ' - ' : '') + service.description;
}
